import { CommonModule } from '@angular/common';
import { Component, Input, SimpleChanges } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { EducationProgramDTO } from '@core/apis/education/education.dto';
import { RehabilitationProgramDTO } from '@core/apis/rehabilitation/rehabilitation.dto';
import { ServiceDTO } from '@core/apis/service/service.dto';
import { IImage } from '@core/interfaces/booking.interface';
import { IMaps } from '@core/interfaces/interface';
import { TranslocoModule } from '@jsverse/transloco';
import { GoogleMapLauncherComponent } from '../google-map-launcher/google-map-launcher.component';
import { ProgramPhotosComponent } from '../program-photos/program-photos.component';
import { TabEnum } from './enum';

@Component({
  selector: 'app-program-tabs',
  imports: [CommonModule, ProgramPhotosComponent, TranslocoModule, GoogleMapLauncherComponent],
  standalone: true,
  templateUrl: './program-tabs.component.html',
  styleUrls: ['./program-tabs.component.scss'],
})
export class ProgramTabsComponent {
  @Input({ required: true }) public program!: RehabilitationProgramDTO | EducationProgramDTO | ServiceDTO;

  public clinicPath: string = '';
  @Input() public teamPath: string = '';

  public teamImages: IImage[] = [];
  public clinicImages: IImage[] = [];

  public clinicDescription: SafeHtml = '';
  public programDescription: SafeHtml = '';
  public activeTabIndex: number | null = null;

  public readonly tabs = [
    { id: TabEnum.program, icon: 'bi bi-list' },
    { id: TabEnum.about, icon: 'bi bi-person' },
    { id: TabEnum.map, icon: 'bi bi-geo-alt' },
    { id: TabEnum.gallery, icon: 'bi bi-images' },
  ];

  public readonly TabEnum = TabEnum;
  public maps!: IMaps;
  constructor(private readonly sanitizer: DomSanitizer) {}

  public ngOnInit(): void {
    this.maps = {
      lat: Number(this.program.maps?.lat),
      lng: Number(this.program.maps?.lng),
    };
    this.clinicPath = `clinics/${'clinic_id' in this.program ? this.program.clinic_id : (this.program as ServiceDTO).clinicId}/files`;
    this.updateImages();
  }

  public ngOnChanges(changes: SimpleChanges): void {
    if (changes['program']) {
      this.updateDescriptions();
      this.updateImages();
    }
  }

  public toggleTab(index: number): void {
    this.activeTabIndex = this.activeTabIndex === index ? null : index;
  }

  public onCloseDetails(): void {
    this.activeTabIndex = null;
  }

  private updateDescriptions(): void {
    if (this.program) {
      this.clinicDescription = this.sanitizer.bypassSecurityTrustHtml(
        this.program.clinic?.description || 'No description available',
      );

      this.programDescription = this.sanitizer.bypassSecurityTrustHtml(
        this.program?.description || 'No description available',
      );
    }
  }

  private updateImages(): void {
    this.teamImages =
      this.program.files?.map((file) => ({
        key: file.awsBucketFileKey,
        path: this.teamPath,
      })) ?? [];

    this.clinicImages =
      this.program.clinic.files?.map((file) => ({
        key: file.awsBucketFileKey,
        path: this.clinicPath,
      })) ?? [];
  }
}
